import { render, staticRenderFns } from "./BibleAiAssistant.vue?vue&type=template&id=bdd1a840&scoped=true"
import script from "./BibleAiAssistant.vue?vue&type=script&lang=js"
export * from "./BibleAiAssistant.vue?vue&type=script&lang=js"
import style0 from "./BibleAiAssistant.vue?vue&type=style&index=0&id=bdd1a840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd1a840",
  null
  
)

export default component.exports